"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { parseDataLocationPath } from '@membranehq/sdk';
import { useMembrane } from '../../contexts/use-integration-app.mjs';
import useSWR from 'swr';

function useDataCollectionSpec({
  path,
  key,
  integrationId
}) {
  const client = useMembrane();
  const dataCollectionKey = key ?? parseDataLocationPath(path)?.key;
  const {
    data: dataCollectionSpec,
    isLoading: loading,
    error,
    isValidating: refreshing
  } = useSWR(
    dataCollectionKey && integrationId ? `/integrations/${integrationId}/data/${dataCollectionKey}` : null,
    async () => {
      return client.integration(integrationId).getDataCollection(dataCollectionKey);
    }
  );
  return { dataCollectionSpec, loading, error, refreshing };
}

export { useDataCollectionSpec };
